import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'JR',
  quote: 'Organicé toda mi especialización en geomecánica en una semana',
  name: 'Jorge R.',
  location: 'Mendoza | Ingeniero de Minas'
}, {
  initials: 'CP',
  quote: 'Por fin domino Leapfrog y Vulcan sin haber pagado $800 dólares en cursos',
  name: 'Carla P.',
  location: 'San Juan | Técnica Minera'
}, {
  initials: 'ML',
  quote: 'El pack de seguridad me ayudó a aprobar la auditoría interna de la empresa',
  name: 'Marcos L.',
  location: 'Jujuy | Supervisor Minero'
}];
export function ShortTestimonials() {
  return <section className="py-16 px-4 bg-brand-gray" data-id="element-259">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-260">
        {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 flex flex-col items-center text-center" data-id="element-261">
            <div className="w-16 h-16 bg-brand-blue text-white rounded-full flex items-center justify-center text-xl font-bold mb-4" data-id="element-262">
              {t.initials}
            </div>
            <div className="flex text-yellow-400 mb-4" data-id="element-263">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-264" />)}
            </div>
            <p className="text-lg font-bold text-gray-800 mb-4 italic" data-id="element-265">
              "{t.quote}"
            </p>
            <p className="text-sm text-gray-500 font-medium" data-id="element-266">
              — {t.name}, {t.location}
            </p>
          </div>)}
      </div>
    </section>;
}